import React from "react";
import "../../../css/DesignSystem/SelectionControls/SelectionControls.css";

const normaliseOptions = (options = []) =>
  options.map((opt) =>
    typeof opt === "object" ? opt : { value: opt, label: opt },
  );

const RadioGroup = ({
  label,
  name,
  options = [],
  value,
  onChange,
  columns = 1,
  deselectable = false,
}) => {
  const parsed = normaliseOptions(options);
  const groupName = name || label;

  return (
    <div className="smSelectionGroup">
      {label && <div className="FP_Content_Semibold">{label}</div>}

      <div
        className="smSelectionGrid"
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      >
        {parsed.map((opt) => (
          <label key={opt.value} className="smInlineOption">
            <input
              type="radio"
              name={groupName}
              checked={value === opt.value}
              onClick={() => {
                if (deselectable && value === opt.value) {
                  onChange(null);
                }
              }}
              onChange={() => {
                if (value !== opt.value) {
                  onChange(opt.value);
                }
              }}
            />
            <span className="smRadioBox" />
            <span
              className={`smOptionLabel ${value === opt.value ? "FP_Content_Semibold primary-text" : "FP_Content"}`}
            >
              {opt.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
